import { useEffect, useMemo, useState } from 'react'
import { Resource } from '@prometheus/types'
import { getResourceShortages } from '../utils/getResourceUsageForecast'

export const RESOURCE_FLASH_MS = 5000

/**
 * Flags the resources a player cannot cover for the coming year, for a few
 * seconds at the start of every turn. The window opens on each turn change and
 * closes on a timer; while it is open the flags track the CURRENT shortfall, so
 * covering a resource mid-flash stops it flashing.
 */
export const useResourceShortageFlash = (
  turn: number | undefined,
  net_forecast: (Resource & { [key: string]: number }) | undefined,
  duration: number = RESOURCE_FLASH_MS,
): Record<string, boolean> => {
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (turn === undefined) {
      return
    }
    setActive(true)
    const timeout = setTimeout(() => setActive(false), duration)
    return () => clearTimeout(timeout)
  }, [turn, duration])

  const shortages = getResourceShortages(net_forecast).join(',')

  return useMemo(() => {
    if (!active || !shortages) {
      return {}
    }
    return shortages.split(',').reduce<Record<string, boolean>>((acc, resource) => {
      acc[resource] = true
      return acc
    }, {})
  }, [active, shortages])
}
